import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserController from "../../../../services/system/user/user-controller";
import {getSchoolAbbreviationName, getSchoolYear} from "../../../../utils/authority";
import Utils from "../../../../utils/utils";

class modalCreateUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '12345678@@',
            reason: '',
            preUsername: getSchoolAbbreviationName(),
            showBlock: true,
            signupInfo: null
        };
    }

    createUser = () => {
        let yearId = getSchoolYear()
        let payload = {
            "fullName": this.state.fullname,
            "group": this.state.role,
            "password": this.state.password,
            "status": this.state.status?"ACTIVE":"INACTIVE",
            "username": this.state.preUsername+ "_"+this.state.username,
            "yearId": yearId,
            "module": "QLTS"
        }
        UserController.createUser(payload, res => {
            if (res.success) {
                toast.success("Thêm người dùng thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới người dùng</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên đăng nhập(<span  style={{color: "red",}}>*</span>)</label>
                                    <label
                                        className="pl-0 font-weight-bold kt-margin-b-10-tablet-and-mobile pt-1">
                                        {this.state.preUsername}_
                                    </label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập tên đăng nhập"
                                        className="form-control shadow-none"
                                        value={this.state.username}
                                        onChange={(event) => {
                                            this.setState({
                                                username: Utils.filterNormalCharacter(event.target.value).trim()
                                            })
                                        }}
                                    />
                                </div>

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên hiển thị(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập tên hiển thị"
                                        className="form-control shadow-none"
                                        value={this.state.fullname}
                                        onChange={(event) => {
                                            this.setState({
                                                fullname: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Nhóm người dùng(<span  style={{color: "red",}}>*</span>)</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.role}
                                        onChange={(e) => {
                                            this.state.role = e.target.value;
                                            this.setState({
                                                role: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="1">Tất cả</option>
                                        {this.props.listGroupUser?.map((item, index) => <option value={item.role}>{item.role}</option>)}
                                    </select>
                                </div>
                                <div className="col-12 d-flex mt-3">
                                    <label className="col-6 label-item pl-0"></label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.status;
                                                this.setState({status: !value});
                                            }}
                                            checked={this.state.status}
                                        />
                                        {' '}
                                        Kích hoạt
                                    </label>
                                </div>

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Mật khẩu mặc định</label>
                                    <label className="col-6 label-item pl-0">{this.state.password}</label>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createUser()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default modalCreateUser
